/*-----------------------------------
 * MP hayabusa Customize
 * [このファイルの役割]
 * ・プラグインの読み込み
 * ・URLによるモジュールの実行
 * ・サイト設定
 * ・URLによるCSS読み込み設定
 *-----------------------------------*/

import 'jquery.easing'
import './plugins/plugins'
import './plugins/utility'
import INIT from './modules/init'

// ページ読み込み
import HOME from './page/home'
import ABOUT from './page/about';
import SERVICE from './page/service';
import CASE from './page/case';


/*****
 * サイト設定
 */
window.siteinfo = {
  tagmanager:       'GTM-NLXC475',
  viewport:         'width=1200',
  mapApiKeys: {
    'local':                  'AIzaSyCTB3MSMYkTjSz6l30k79XflmmL_FcOxkg', //development
    'www.living-sanai.co.jp': 'AIzaSyBeqmCPvmXe1wQVEa812o_YHtkqip9Hy1k' //production
  },
  map:[{
    latlng:'34.7259469,137.7311803',
    title:'株式会社リビングサンアイ',
    address:'〒430-0907 静岡県浜松市中区高林1丁目9-38',
    icon:'/asset/img/home/sanai_map.png',
    zoom: '16',
    iconSize:'50,76'
  }],
  sextable: {
    3: 'male', // Hiroshi Asai
    4: 'female', // Mina Kanda
    5: 'female', // Kasumi Noyori
    6: 'male', // Hiroki Matsui
    7: 'female', // Mari Huruhashi
    8: 'male', // Tsuyoshi Hujikawa
    9: 'male', // Keisuke Nishinabe
  }
}

/*****
 * サイト初期化
 */
INIT()

/*****
 * コンテンツごとのファイル読み込み
 */
$.require({
  disableCache:false,
  '*':{
    '/': ['(css)/asset/css/home.min.css?ts=20190226'],
    '/aboutus': ['(css)/asset/css/page/aboutus.min.css?ts=20200424'],
    '/service': ['(css)/asset/css/page/service.min.css?ts=20200424'],
    '/case_study': ['(css)/asset/css/page/case.min.css?ts=20190528']
  },
})
switch(location.pathname.replace('main.php','')){
  // トップページ
  case '/': HOME(); break
  case '/aboutus/': ABOUT(); break
  case '/service/': SERVICE(); break
  case '/case_study/': CASE(); break
}
